import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { Button, Column, Grid, Link } from '../../Blocks'
import OrderSummary from '../OrderSummary'
import { closePopups, resetModel } from '../../../utilities'

const ModalOrderConfirmed = () => {
  const designAnother = (e) => {
    // console.log('starting again!')
    resetModel()
    closePopups(e)
    // state.modal.selectModel = true
    // state.modal.open = true
  }
  //   console.log('Connect3')
  return (
    <Column>
      <h2>Added to Cart!</h2>
      <OrderSummary />
      <Grid cols="1fr" justify="center">
        <Button handleClick={(e) => designAnother(e)}>Design Another</Button>
        <Link link="/shop">
          {' '}
          <Button fullWidth>Go back to shop</Button>
        </Link>
        <Link link="/checkout">
          <Button fullWidth accent>
            Go to Checkout!
          </Button>
        </Link>
      </Grid>
    </Column>
  )
}

export default ModalOrderConfirmed

